"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { getLearnMoreByPath } from "@/lib/seo/toolLearnMoreCatalog";

/** Inline CTA (no portal) — reserves layout on first paint and avoids CLS. */
export default function ToolLearnMoreInlineCta() {
  const pathname = usePathname();

  const pathOnly = String(pathname || "").split("?")[0].split("#")[0];
  const normalized = pathOnly.endsWith("/") && pathOnly !== "/" ? pathOnly.slice(0, -1) : pathOnly;

  if (!normalized || normalized.endsWith("/learn-more")) return null;
  // Smart Sell paints this CTA on the page surface so it does not sit on a
  // different canvas color after <main>.
  if (normalized === "/smart-sell") return null;

  const tool = getLearnMoreByPath(pathname);
  if (!tool?.learnMorePath) return null;

  return (
    <section
      className="mx-auto mb-8 w-full max-w-6xl px-4 sm:mb-10 sm:px-6 lg:px-8"
      data-tool-learn-more-cta
    >
      <div className="rounded-xl border border-cyan-500/25 bg-cyan-500/10 p-4 sm:p-5">
        <p className="text-sm leading-6 text-cyan-100">
          Want the full strategy before you run{" "}
          <span className="font-semibold">{tool.toolName}</span>?
        </p>
        <Link
          href={tool.learnMorePath}
          className="mt-2 inline-flex items-center rounded-lg bg-cyan-500 px-3 py-2 text-sm font-semibold text-black hover:bg-cyan-400 sm:mt-3"
          rel="noopener noreferrer"
        >
          Read the full guide
        </Link>
      </div>
    </section>
  );
}
